import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { Heading, T } from "../components/helpful";
import { accept, reject } from "../components/utilities";
import { link } from "../config";
import { Toast } from "primereact/toast";
import { BlockUI } from "primereact/blockui";
import * as formik from "formik";
import { ErrorMessage } from "formik";
import * as yup from "yup";

/* The Account class in JavaScript handles account updates with form validation and submission,
displaying status messages and blocking UI during the process. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/

export default class Account extends React.Component {

  constructor() {
    super();
    this.state = {
      pageTitle: <T value={"My account"} />,
      desc: <T value={"Change your personal data"} />,
      blockedPanel: false,
      
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.showStatusMsg = this.showStatusMsg.bind(this);
  }

  onSubmit = (values) => {
    const formData = JSON.stringify({ formData: values });
    this.setState({ blockedPanel: true });
    fetch(link + "register", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json, text/plain, */*",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          this.showStatusMsg(true, "Account updated successfully.");
        } else {
          this.showStatusMsg(true, "Account update failed.");
        }
        this.setState({ blockedPanel: false });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  showStatusMsg(status, msg) {
    if (status) {
      this.toast.show({
        severity: "success",
        detail: msg,
        life: 3000,
        sticky: true,
      });
    } else {
      this.toast.show({
        severity: "error",
        detail: msg,
        life: 3000,
        sticky: true,
      });
    }
  }

  subHeading = () => {
    return <>{this.state.desc}</>;
  };

  render() {
    const { Formik } = formik;
    const countries = this.props.countries;
    const titles = this.props.titles;
    const user = this.props.user;
    

    if (Object.keys(user).length === 0) {
      return <div>Loading...</div>;
    }

    const phoneRegExp = /^(\+\d{1,2}\s?)?(\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}|\d{8,10}|\+\d{3}\s\d{7,8})$/;

    const schema = yup.object().shape({
      title: yup
        .string()
        .required(<T value={"Title is required"} />)
        .notOneOf(["0"], <T value={"Title is required"} />),
      userType: yup
        .number()
        .required(<T value={"User Type is required"} />)
        .notOneOf([0], <T value={"User Type is required"} />),
      moreInfo: yup.string().optional(),
      address: yup.string().required(<T value={"Address is required"} />),
      firstname: yup.string().required(<T value={"First Name is required"} />),
      lastname: yup.string().required(<T value={"Last Name is required"} />),
      email: yup
        .string()
        .email(<T value={"Invalid email address"} />)
        .required(<T value={"Email is required"} />),
      dateOfBirth: yup
        .string()
        .required(<T value={"Date of Birth is required"} />),
      country: yup
        .number()
        .required(<T value={"Country is required"} />)
        .notOneOf(["0"], <T value={"Country is required"} />),
      company: yup.string().optional(),
      telephone: yup
        .string()
        .matches(phoneRegExp, <T value={"Telephone number is not valid"} />)
        .required(<T value={"Telephone is required"} />),
      mobile: yup
        .string()
        .matches(phoneRegExp, <T value={"Mobile number is not valid"} />)
        .optional(),
      fax: yup
        .string()
        .matches(phoneRegExp, <T value={"Fax number is not valid"} />)
        .optional(),
        unsuscribe: yup.boolean().optional(),
        username: yup.string().optional(),
    });
console.log('user:',user);

    return (
      <div>
        <div>
          <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
        </div>
        <div className="main-content b2b-form py-5">
        <BlockUI
                  blocked={this.state.blockedPanel}
                  template={<span className="saving-block "> saving...</span>}
                >
          <Formik
            validationSchema={schema}
            onSubmit={this.onSubmit}
            initialValues={{
              userID: user.userID ? user.userID : 0,
              title: user.userTitle ? user.userTitle : "",
              userType: user.userGroupTypeID ? user.userGroupTypeID : "",
              address: user.userAddress ? user.userAddress : "",
              moreInfo: "",
              firstname: user.userOthername ? user.userOthername : "",
              lastname: user.userSurname ? user.userSurname : "",
              email: user.userEmail ? user.userEmail : "",
              dateOfBirth: user.userDOB ? user.userDOB : "", 
              country: user.userCountryID ? user.userCountryID : "",
              company: user.userCompany ? user.userCompany : "",
              telephone: user.userPhone ? user.userPhone : "",
              mobile: user.userMobile ? user.userMobile : "",
              fax: user.userFax ? user.userFax : "",
              unsuscribe: user.optOutSent ? user.optOutSent : false,
              username: user.user_login_name ? user.user_login_name : null,
            }}
          >
            {({
              handleSubmit,
              handleChange,

              values,
              touched,
              errors,
              handleBlur,
              isSubmitting,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>

                  <Toast
                    ref={(el) => (this.toast = el)}
                    position="bottom-right"
                  />
                  <Row className="g-3 ">
                    <Form.Group as={Col} md="6" controlId="">
                      <FloatingLabel label={<T value={"Title"} />} className="">
                        <Form.Select
                          aria-label=""
                          id="title"
                          name="title"
                          className="custom-input"
                          placeholder={<T value={"Title"} />}
                          value={values.title}
                          onChange={handleChange}
                          isInvalid={!!errors.title}
                        >
                          <option key={0} value={0}>
                            Select Title
                          </option>
                          {titles.map((title, index) => {
                            return (
                              <option key={index + 1} value={title}>
                                {title}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <ErrorMessage
                          name="title"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <FloatingLabel
                        label={<T value={"Date of birth"} />}
                        className=""
                      >
                        <Form.Control
                          type="date"
                          id="dateOfBirth"
                          className="custom-input"
                          name="dateOfBirth"
                          value={values.dateOfBirth}
                          onChange={handleChange}
                          isInvalid={!!errors.dateOfBirth}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.dateOfBirth}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                  <Row className="g-3 ">
                    <Form.Group as={Col} md="6">
                      <FloatingLabel
                        label={<T value={"First Name"} />}
                        className=""
                      >
                        <Form.Control
                          type="text"
                          id="firstname"
                          className="custom-input"
                          placeholder={<T value={"First Name"} />}
                          name="firstname"
                          value={values.firstname}
                          onChange={handleChange}
                          isInvalid={!!errors.firstname}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.firstname}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <FloatingLabel
                        label={<T value={"Last Name"} />}
                        className=""
                      >
                        <Form.Control
                          type="text"
                          id="lastname"
                          className="custom-input"
                          placeholder={<T value={"Last Name"} />}
                          name="lastname"
                          value={values.lastname}
                          onChange={handleChange}
                          isInvalid={!!errors.lastname}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.lastname}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                  <Row className="g-3 mb-2">
                    <Form.Group as={Col} md="12">
                      <FloatingLabel
                        label={<T value={"Address"} />}
                        className=""
                      >
                        <Form.Control
                          as="textarea"
                          rows={5}
                          id="address"
                          name="address"
                          value={values.address}
                          onChange={handleChange}
                          isInvalid={!!errors.address}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.address}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>
                  <Row className="g-3 mb-2">
                    <Form.Group as={Col} md="6">
                      <FloatingLabel label={<T value={"Email"} />} className="">
                        <Form.Control
                          type="email"
                          id="email"
                          className="custom-input"
                          placeholder={<T value={"Email"} />}
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <FloatingLabel
                        label={<T value={"Company"} />}
                        className=""
                      >
                        <Form.Control
                          type="text"
                          id="company"
                          className="custom-input"
                          placeholder=""
                          name="company"
                          value={values.company}
                          onChange={handleChange}
                          isInvalid={!!errors.company}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.company}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>

                  <Row className="g-3 mb-2">
                    <Form.Group as={Col} md="6" controlId="">
                      <FloatingLabel
                        label={<T value={"Country"} />}
                        className=""
                      >
                        <Form.Select
                          aria-label=""
                          name="country"
                          className="custom-input"
                          placeholder="Select country"
                          value={values.country}
                          onChange={handleChange}
                          isInvalid={!!errors.country}
                        >
                          <option key={0} value={0}>
                            {"Select country"}
                          </option>
                          {countries.map((country, index) => {
                            return (
                              <option key={index + 1} value={country.id}>
                                {country.description}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <ErrorMessage
                          name="country"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <FloatingLabel
                        label={<T value={"Telephone"} />}
                        className=""
                      >
                        <Form.Control
                          type="text"
                          id="telephone"
                          className="custom-input"
                          placeholder={<T value={"Telephone"} />}
                          name="telephone"
                          value={values.telephone}
                          onChange={handleChange}
                          isInvalid={!!errors.telephone}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.country}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                  </Row>

                  <Row className="g-3 ">
                    <Form.Group as={Col} md="6">
                      <FloatingLabel
                        label={<T value={"Mobile"} />}
                        className=""
                      >
                        <Form.Control
                          type="text"
                          id="mobile"
                          className="custom-input"
                          placeholder={<T value={"Mobile"} />}
                          name="mobile"
                          value={values.mobile}
                          onChange={handleChange}
                          isInvalid={!!errors.mobile}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.mobile}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <FloatingLabel label={<T value={"Fax"} />} className="">
                        <Form.Control
                          type="text"
                          id="fax"
                          placeholder={<T value={"Fax"} />}
                          name="fax"
                          className="custom-input"
                          value={values.fax}
                          onChange={handleChange}
                          isInvalid={!!errors.fax}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.fax}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </Form.Group>
                    <div className="mb-4">
                            <input
                              type="checkbox"
                              id="unsuscribe"
                              name="unsuscribe"
                              checked={values.unsuscribe}
                              onChange={handleChange}
                              className="me-3"
                            />
                            <label htmlFor="unsuscribe">
                              I want to receive notification emails
                              <span className=""> </span>
                            </label>
                          </div>
                  </Row>
                  <button
                    type="submit"
                    // disabled={isSubmitting}
                    className="col-12   btn  bcb-btn-primary bcb-btn-small text-capitalize "
                  >
                    {<T value={"Save"} />}
                  </button>
                
              </Form>
            )}
          </Formik>
          </BlockUI>
        </div>
      </div>
    );
  }
}
